import {
  ADD_SCALE_CAMERA_FAIL,
  ADD_SCALE_CAMERA_REQUEST,
  ADD_SCALE_CAMERA_SUCCESS,
  DELETE_SCALE_CAMERA_FAIL,
  DELETE_SCALE_CAMERA_REQUEST,
  DELETE_SCALE_CAMERA_SUCCESS,
  GET_SCALE_CAMERA_LIST_REQUEST,
  GET_SCALE_CAMERA_LIST_FAIL,
  GET_SCALE_CAMERA_LIST_SUCCESS,
  GET_SCALE_CAMERA_FAIL,
  GET_SCALE_CAMERA_REQUEST,
  GET_SCALE_CAMERA_SUCCESS,
  UPDATE_SCALE_CAMERA_FAIL,
  UPDATE_SCALE_CAMERA_REQUEST,
  UPDATE_SCALE_CAMERA_SUCCESS,
} from "src/constants/types";

export const scaleCameraReducers = (state = {}, actions) => {
  switch (actions.type) {
    case GET_SCALE_CAMERA_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SCALE_CAMERA_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        scaleCameraList: actions.payload,
        error: "",
      };
    case GET_SCALE_CAMERA_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case DELETE_SCALE_CAMERA_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_SCALE_CAMERA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case DELETE_SCALE_CAMERA_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case ADD_SCALE_CAMERA_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_SCALE_CAMERA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case ADD_SCALE_CAMERA_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_SCALE_CAMERA_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SCALE_CAMERA_SUCCESS:
      return {
        ...state,
        loading: false,
        scaleCamera: actions.payload,
      };
    case GET_SCALE_CAMERA_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case UPDATE_SCALE_CAMERA_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case UPDATE_SCALE_CAMERA_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_SCALE_CAMERA_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
